module.exports = __webpack_public_path__ + "img/patrocinadores-copa-prosa-28nov.86e3d11d.jpg";